export default "__VITE_ASSET__d6882e74__"